<template>
  <div>
    <div class="flex-center flex-col">
      <div class="w-full">
        <div id="caption" class="bg-main text-white mb-4 h-12 leading-12 -mx-4">{{ $t(" 配货单") }}</div>

        <div class="tr trs th">
          <div v-for="(th, i) in ths" :key="i">{{ $t(th) }}</div>
        </div>
        <div
          ref="scroll"
          class="trs pr-2 w-full overflow-y-scroll overflow-x-hidden max-h-15vh scrollbar"
        >
          <div
            class="tr animate-duration-500 animate-zoom-in animate-repeat-1"
            v-for="item in items"
            :key="item.cid"
            :id="item.id"
          >
            <div class="text-left !justify-start">{{ item.name }}</div>
            <div>{{ item._weight.value }}</div>
            <div>
              <el-input-number
                v-model.number="item._num.value"
                size="mini"
                :min="1"
                :max="item.stock"
                @change="chHandle(item.id, item._num.value)"
              ></el-input-number>
            </div>
            <div>{{ $p(item.price) }}</div>
            <div>{{ $p(item._count.value) }}</div>
            <div>
              <span class="iconfont icon-shanchu cursor-pointer" @click="delItem(item.id)"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="mr-auto">
        <p class="space-x-10 mt-4" v-if="items.length">
          <span>{{ $t("品种") }}：{{ items.length }}</span>
          <span>{{ $t("数量") }}：{{ items._total.value }}</span>
          <span>{{ $t("估重") }}：{{ items._weight.value }} KG</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from "@vue/composition-api";
import bus from "@/API/util/bus.js";
import {
  compose,
  findIndex,
  lensProp,
  map,
  path,
  pipe,
  pluck,
  prop,
  propEq,
  remove,
  set,
  sum,
  find,
  last,
} from "ramda";
export default {
  setup(props, ctx) {
    const ths = ["品名", "重量", "数量", "单价", "金额", "删除"];
    // 在单个商品中设置 数量*价格 和 数量*重量
    const setNum = (val) => set(lensProp("_num"), ref(val));

    const setCount = (obj) =>
      set(
        lensProp("_count"),
        computed(() => prop("price", obj) * path(["_num", "value"], obj)),
        obj
      );
    const setWeight = (obj) =>
      set(
        lensProp("_weight"),
        computed(() => prop("weight", obj) * path(["_num", "value"], obj)),
        obj
      );
    // 设置arry最外层的属性，也就是 和array.length 同层的属性
    const addItemsProps = () => {
      const getWeight = pipe(pluck("_weight"), pluck("value"), sum);
      const getTotal = pipe(pluck("_num"), pluck("value"), sum);
      Reflect.defineProperty(items.value, "_weight", {
        writable: true,
        value: computed(() => getWeight(items.value)),
      });
      Reflect.defineProperty(items.value, "_total", {
        writable: true,
        value: computed(() => getTotal(items.value)),
      });
    };

    // 获取航班id
    // const flight_id = ctx.root.$route.params.id;
    // 初始化items，从服务器获取购物车信息
    const items = ref([]);
    onMounted(async () => {
      const res = (
        await ctx.root.$callapi("trade/getMyCartList")
      ).data;
      if(!res)return
      res?.map(item => {
        item.product.cid = item.id
      })
      let k = map(({ product, quantity }) =>
        compose(setCount, setWeight, setNum(ref(quantity)))(product)
      )(res);
      items.value = k;

      // 设置arry最外层的属性，也就是 和array.length 同层的属性
      // 有2个属性 分别是 _weight，_total
      addItemsProps();
    });

    const scroll = ref();

    onMounted(() => {
      watch(
        () => items.value.length,
        () => {
          // 自动翻页到最后
          const f = last(scroll.value.children);
          scroll.value.scrollTop = f?.offsetTop;
        }
      );
    });

    bus.on("select", async (e) => {
      const isExist = items.value?.find(item => item.id == e.id)
      if (!isExist) {
        let res = await ctx.root.$callapi("trade/editWithCart", {
          pid: e.id,
          quantity: 1,
        });
        if (res.code == 0 && res.data) {
          e.cid = res.data.id

          const setProps = pipe(setNum(ref(1)), setCount, setWeight)(e);
          items.value.push(setProps)
        }
        return
      }
      const f = find(
        (val) => parseInt(val.getAttribute("id")) === isExist.id
      )(scroll.value.children);
      if (f?.offsetTop) {
        scroll.value.scrollTop =
          f.offsetTop - scroll.value.offsetHeight + f.offsetHeight;
        // 添加动画
        // const normal_class = f.getAttribute("class")
        const normal_class = "tr";
        const running =
          " animate-duration-500 animate-wobble animate-repeat-1";
        f.className = normal_class + running;

        setTimeout(() => {
          f.className = normal_class;
        }, 600);
      }


      chHandle(isExist.id, isExist._num.value++);


      // ctx.emit("goods-list", items.value);
    });
    // 删除键
    const delItem = async (id) => {
      const index = findIndex(propEq("id", id), items.value);

      items.value = remove(index, 1, items.value);
      addItemsProps();

      try {
        let res = await ctx.root.$callapi("trade/editWithCart", {
          pid: id,
          quantity: -1,
        });
        if (res.code == 0 && res.data) {
          ctx.root.$store.commit("REMOVE_CART", id);
        }

      } catch (e) {
        return e;
      }
    };

    watch(items, (v) => {
      ctx.emit("goods-list", v);
    }, {
      deep:true
    });
    // 更改数量
    const chHandle = async (id, num) => {
      await ctx.root.$callapi("trade/editWithCart", { pid: id, quantity: num });
    };

    return { items, ths, delItem, chHandle, scroll };
  },
};
</script>

<style scoped lang="scss">
.head > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.th {
  font-weight: 700;
  height: 2.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
}
.td {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
  border-width: 1px;
  margin-top: -1px;
  margin-right: -1px;
  padding: 1px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.tr {
  display: -ms-grid;
  display: grid;
  margin-left: 1px;
  margin-right: 1px;
  grid-template-columns: 9rem 4rem 6rem 4rem 5rem 3rem;
}
.tr > div {
  @extend .td;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  line-height: 1;
}
.trs {
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  -webkit-transform: rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z));
  -ms-transform: rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z));
  transform: rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) translateZ(var(--tw-translate-z));
  --tw-translate-x: 0.25rem;
}
.scrollbar {
  scroll-behavior: smooth;
}
.scrollbar::-webkit-scrollbar {
  width: 5px;
}
.scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
}
.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.247);
}
</style>
